function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M7.3,0C3.3,0,0,3.3,0,7.3s3.3,7.3,7.3,7.3s7.3-3.3,7.3-7.3S11.3,0,7.3,0z M7.3,13.4c-3.4,0-6.1-2.7-6.1-6.1 c0-3.4,2.7-6.1,6.1-6.1c3.4,0,6.1,2.7,6.1,6.1C13.4,10.7,10.7,13.4,7.3,13.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.8,3.7H6.7c-0.1,0-0.2,0.1-0.2,0.1C6.4,3.9,6.4,3.9,6.4,4v1c0,0.1,0,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1h1.1 c0.1,0,0.1,0,0.2-0.1C8.1,5.1,8.1,5.1,8.1,5V4c0-0.1,0-0.1-0.1-0.2C7.9,3.7,7.9,3.7,7.8,3.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.8,6.3H6.7c-0.1,0-0.2,0.3-0.2,0.3C6.4,6.9,6.4,6.9,6.4,7.2v3.1c0,0.3,0,0.3,0.1,0.6c0.1,0.3,0.1,0.3,0.2,0.3h1.1 c0.1,0,0.1,0,0.2-0.3c0.1-0.3,0.1-0.3,0.1-0.6V7.2c0-0.3,0-0.3-0.1-0.6C7.9,6.3,7.9,6.3,7.8,6.3z"
}));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.6 14.6",
    style: {
      enableBackground: "new 0 0 14.6 14.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.1c7bca34.svg";
export { ForwardRef as ReactComponent };